import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const TicketTypeDetailsView = ({ event, ticketType, handleClose }) => {
  if (!Boolean(event) || !Boolean(ticketType)) {
    return;
  }
  const { ticketTypeStats } = event;
  const { name, key, description, usdCents } = ticketType;

  // Check if ticketTypeStats exists and find the matching ticket type
  const ticketStats = ticketTypeStats?.find(({ id }) => id === key);
  if (!ticketStats) {
    return;
  }
  const { capacity, capacityPerPerson } = ticketStats;
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const priceText = USDollar.format(usdCents / 100);

  const capacityValueText = Boolean(capacity) ? `${capacity}` : "Unlimited";
  const capacityPerPersonValueText = `${capacityPerPerson}`;
  return (
    <Box>
      <Box display={"flex"} justifyItems={"top"}>
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "6",
            WebkitBoxOrient: "vertical",
            marginTop: "0px",
          }}
          fontWeight={"bold"}
          variant="h5"
          flexGrow={"1"}
        >
          {name}
        </Typography>
        <IconButton
          sx={{ height: "45px", width: "45px" }}
          onClick={() => {
            handleClose();
          }}
        >
          <Close />
        </IconButton>
      </Box>
      <Typography marginTop={"10px"} variant="body1">
        {description}
      </Typography>
      <Box display={"flex"} gap={"20px"} marginTop={"20px"}>
        <Typography fontWeight={"bold"}>Capacity</Typography>
        <Typography>{capacityValueText}</Typography>
      </Box>
      <Box display={"flex"} gap={"20px"} marginTop={"20px"}>
        <Typography fontWeight={"bold"}>Capacity Per Person</Typography>
        <Typography>{capacityPerPersonValueText}</Typography>
      </Box>
      <Box display={"flex"} gap={"20px"} marginTop={"20px"}>
        <Typography fontWeight={"bold"}>Ticket Price</Typography>
        <Typography>{priceText}</Typography>
      </Box>
    </Box>
  );
};

export default TicketTypeDetailsView;
